import { takeEvery, select, put, call, all } from "redux-saga/effects";
import {
  ADD_TO_USED,
  ADD_TO_USED_LIST,
  loadUsedList,
  mode,
} from "../../../store/Settings/actions/components/BackgroundLists";
import {
  hideAlertInfo,
  showAlertError,
  showAlertInfo,
} from "../../../store/Alert/actions";
import axios from "axios";
import { loadObjects } from "../../../store/Objects/actions";

export default function* () {
  yield takeEvery(ADD_TO_USED_LIST, worker);
}

function* worker({ payload }) {
  const { selectedTimeLines, availSelected } = payload;
  const total = selectedTimeLines.length;
  let completed = 0;

  yield put(
    showAlertInfo({
      text: `Добавление... 0 из ${total}`,
      loader: true,
    })
  );

  // Запускаем все параллельно
  const tasks = selectedTimeLines.map((timelineId) =>
    call(function* () {
      const res = yield call(fetchAddToUsed, timelineId, availSelected);

      completed++;
      yield put(
        showAlertInfo({
          text: `Добавление... ${completed} из ${total}`,
          loader: true,
        })
      );

      if (!res.error) {
        yield put(
          loadUsedList({
            timelineId,
            required: true,
          })
        );
      } else {
        yield put(
          showAlertError({
            errors: [`Ошибка сервера при ${ADD_TO_USED_LIST}.`, res],
            text: `Ошибка при добавлении ${timelineId}`,
          })
        );
      }
    })
  );

  yield all(tasks);

  yield put(hideAlertInfo());

  yield put(loadObjects());
}

async function fetchAddToUsed(playtimeline_id, playlist_id) {
  try {
    const response = await axios.get("/msbox/play/list/insert", {
      params: { playtimeline_id, playlist_id },
    });
    return response.data;
  } catch (error) {
    return { error };
  }
}
